import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';
import { DeviceSwitcher, getDeviceWidthClass, type DeviceType } from '../ui/DeviceSwitcher';

export function MockupPreview() {
  const mockupHtml = useProjectStore((state) => state.mockupHtml);
  const generateMockup = useProjectStore((state) => state.generateMockup);
  const isGenerating = useProjectStore((state) => state.isGenerating);
  const [device, setDevice] = useState<DeviceType>('desktop');
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((k) => k + 1);
  }, [mockupHtml]);

  return (
    <div className="h-full flex flex-col">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Mockup 預覽</h2>
        <div className="flex items-center gap-2">
          <DeviceSwitcher value={device} onChange={setDevice} />
          <button
            type="button"
            onClick={() => {
              generateMockup();
            }}
            disabled={isGenerating}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white transition-colors"
          >
            <RefreshCw size={14} className={isGenerating ? 'animate-spin' : ''} />
            重新生成
          </button>
        </div>
      </div>

      <div className="flex-1 bg-slate-100 dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">
        <div className="flex-1 overflow-auto p-4 flex justify-center">
          <div className={`${getDeviceWidthClass(device)} h-full transition-all duration-300`}>
            <iframe
              key={key}
              title="Mockup Preview"
              srcDoc={mockupHtml}
              className="w-full h-full min-h-[600px] rounded-lg border border-slate-300 dark:border-slate-600 bg-white"
              sandbox="allow-scripts"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
